var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',{staticClass:"atom-icon-help",attrs:{"icon":"question-circle"},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }